// src/components/quality/CallAssessmentForm.js
import { useState, useEffect } from 'react';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';

const CallAssessmentForm = ({ projectId, onClose, assessment: initialAssessment, onAssessmentUpdated }) => {
  const [assessmentType, setAssessmentType] = useState('call'); // 'call' или 'ticket'
  const [formData, setFormData] = useState({
    agentId: '',
    agentName: '',
    impact: '',
    group: '',
    srq: '',
    status: '',
    url_sound: '',
    url_ticket: '',
    subject2: '',
    feedback: '',
    comment: '',
    criteria: [],
    score: 0,
    maxScore: 0,
    assessment_type: '',
    receipt_channel: '',
    service: '',
    os_specialist: ''
  });
  
  // Состояния для опций выпадающих списков
  const [fieldOptions, setFieldOptions] = useState({
    operators: [],
    impact: [],
    status: [],
    subject2: [],
    assessment_type: [],
    receipt_channel: [],
    service: [],
    os_specialist: [],
    group: []
  });

  const { user } = useAuth();
  const [isEditing, setIsEditing] = useState(false);
  // Загрузка данных редактируемой оценки
  const [hasLoaded, setHasLoaded] = useState(false);
  console.log(initialAssessment)
  // Загрузка данных редактируемой оценки
  useEffect(() => {
    if (initialAssessment && formData.criteria.length > 0 && !hasLoaded) {
      setIsEditing(true);
      const updatedCriteria = formData.criteria.map(criterion => {
        const item = initialAssessment.items.find(i => i.criteria_id === criterion.id);
        return {
          ...criterion,
          selectedOptionId: item ? item.option_id : null,
          score: item ? item.score : 0
        };
      });

      // Устанавливаем значения зависимых полей
      setFieldValues(prev => ({
        ...prev,
        impact: initialAssessment.impact || '',
        srq: initialAssessment.srq || '',
        status: initialAssessment.status || '',
        service: initialAssessment.service || '',
        // os_specialist: initialAssessment.os_specialist || '',
        assessment_type: initialAssessment.assessment_type || '',
        receipt_channel: initialAssessment.receipt_channel || ''
      }));
      
      // Находим оператора по ФИО для получения ID
      const operator = fieldOptions.operators.find(op => `${op.surname} ${op.name}` === initialAssessment.agent_name);
      
      setFormData(prev => ({
        ...prev,
        agentId: operator ? operator.id : '',
        agentName: initialAssessment.agent_name || '',
        impact: initialAssessment.impact || '',
        srq: initialAssessment.srq || '',
        status: initialAssessment.status || '',
        url_sound: initialAssessment.url_sound || '',
        url_ticket: initialAssessment.url_ticket || '',
        subject2: initialAssessment.subject2 || '',
        feedback: initialAssessment.feedback || '',
        comment: initialAssessment.comment || '',
        service: initialAssessment.service || '',
        group: initialAssessment.group || '',
        os_specialist: initialAssessment.os_specialist || '',
        criteria: updatedCriteria,
        score: initialAssessment.total_score || 0,
        maxScore: prev.maxScore,
        assessment_type: initialAssessment.assessment_type || '',
        receipt_channel: initialAssessment.receipt_channel || ''
      }));
      
      setAssessmentType(initialAssessment.assessment_type || '');
      setHasLoaded(true);
    }
  }, [initialAssessment, formData.criteria, hasLoaded]);

  // Состояние для значений полей, от которых зависят критерии
  const [fieldValues, setFieldValues] = useState({
    impact: initialAssessment?.impact || '',
    srq: initialAssessment?.srq || '',
    status: initialAssessment?.status || '',
    service: initialAssessment?.service || '',
    group: initialAssessment?.group || ''
  });
  const [projectName, setProjectName] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // Загрузка критериев проекта по API
  useEffect(() => {
    if (!projectId) return;

    const fetchData = async () => {
      try {
        // Получение операторов
        const operatorsResponse = await api.get(`/operators?project_id=${projectId}`);
        setFieldOptions(prev => ({
          ...prev,
          operators: operatorsResponse.data.operators || []
        }));
        
        // Загрузка критериев
        const criteriaResponse = await api.get(`/quality/criteria?project_id=${projectId}`);
        const criteria = criteriaResponse.data.data || [];
        
        // Фильтруем только активные (не архивные) критерии
        const activeCriteria = criteria.filter(c => !c.archived);
        
        // Рассчитываем maxScore как сумму weight всех не архивных критериев
        const maxScore = activeCriteria.reduce((sum, c) => sum + c.weight, 0);
        
        setFormData((prev) => ({
          ...prev,
          criteria: activeCriteria.map(criterion => ({ 
            ...criterion, 
            score: 0,
            selectedOptionId: null,
            comment: '',
            options: criterion.options || []
          })),
          maxScore: maxScore
        }));
        
        // Загрузка опций для полей
        const fields = ['agent_name', 'impact', 'status', 'subject2', 'assessment_type', 'service', 'os_specialist', 'receipt_channel', 'group'];
        const optionsPromises = fields.map(field =>
          api.get(`/field-options?project_id=${projectId}&field_name=${field}`)
            .then(res => ({
              field,
              options: res.data?.data || []
            }))
            .catch(err => {
              console.error(`Ошибка загрузки опций для поля ${field}:`, err);
              return { field, options: [] };
            })
        );
        
        const optionsResults = await Promise.all(optionsPromises);
        const optionsMap = {};
        optionsResults.forEach(({ field, options }) => {
          optionsMap[field] = options;
        });
        // Сохраняем operators при обновлении других опций
        setFieldOptions(prev => ({
          ...prev,
          ...optionsMap
        }));
        
        setProjectName('Проект'); // Имя проекта не возвращается, оставляем заглушку
      } catch (err) {
        console.error('Ошибка загрузки данных:', err);
        setError('Не удалось загрузить данные. Проверьте подключение или обратитесь к администратору.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [projectId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Обновляем значения зависимых полей
    if (['impact', 'srq', 'status', 'group'].includes(name)) {
      setFieldValues(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleTypeChange = (e) => {
    const value = e.target.value;
    setAssessmentType(value);
  };

  const handleCriteriaOptionChange = (criteriaId, optionId) => {
    setFormData(prev => {
      const newCriteria = prev.criteria.map(criterion => {
        if (criterion.id === criteriaId) {
          const selectedOption = criterion.options.find(opt => opt.id === optionId);
          return {
            ...criterion,
            selectedOptionId: optionId,
            score: selectedOption ? selectedOption.score : 0
          };
        }
        return criterion;
      });
      
      const totalScore = newCriteria.reduce((sum, c) => sum + c.score, 0);
      return { ...prev, criteria: newCriteria, score: totalScore };
    });
  };

  // Удалена функция handleCriteriaCommentChange — комментарии к критериям больше не вводятся


  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      // Проверка обязательных полей
      if (!formData.agentName || !formData.agentName.trim()) {
        setError('Пожалуйста, заполните обязательное поле: ФИО сотрудника');
        setSubmitting(false);
        return;
      }
      console.log(formData.assessment_date)

      console.log(formData.assessment_date)
      // Подготовка данных для отправки
      const payload = {
        project_id: projectId,
        assessment_type: formData.assessment_type,
        receipt_channel: formData.receipt_channel,
        agent_name: formData.agentName.trim(),
        impact: formData.impact,
        srq: formData.srq,
        status: formData.status,
        service: formData.service,
        group: formData.group,
        // url_sound: assessmentType === 'call' ? formData.url_sound : '',
        url_ticket: formData.url_ticket,
        subject2: formData.subject2,
        feedback: formData.feedback,
        comment: formData.comment,
        score: formData.score,
        max_score: formData.maxScore,
        os_specialist: formData.os_specialist,
        items: formData.criteria.map(criterion => ({
          criteria_id: criterion.id,
          option_id: criterion.selectedOptionId
          // комментарий к критерию не передаётся в API
        }))
      };

      // Валидация только отображаемых критериев
      const visibleCriteria = formData.criteria.filter(criterion => {
        return !criterion.dependencies || criterion.dependencies.length === 0 || 
          (criterion.dependencies && 
           criterion.dependencies.some(dep => 
             formData[dep.field_name] && 
             dep.field_value === formData[dep.field_name]
           ));
      });
      
      for (const criterion of visibleCriteria) {
        if (!criterion.selectedOptionId) {
          setError(`Пожалуйста, выберите вариант для критерия "${criterion.name}"`);
          setSubmitting(false);
          return;
        }
      }

      await api.put(`/quality/assessment/${initialAssessment.id}`, payload);
      
      // Успешное обновление
      // alert(`Оценка ${assessmentType === 'call' ? 'звонка' : 'обращения'} обновлена! Общий балл: ${formData.score}/${formData.maxScore}`);
      if (onClose) onClose();
      if (onAssessmentUpdated) onAssessmentUpdated();
    } catch (err) {
      setError('Не удалось сохранить оценку. Попробуйте ещё раз.');
      console.error('Ошибка сохранения оценки:', err);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="modal-content">
        <h3>Загрузка критериев...</h3>
        <div>Пожалуйста, подождите</div>
      </div>
    );
  }

  return (
    <div className="modal-content">
      <div className="modal-header">
        <h3>Оценка качества</h3>
        <button type="button" className="text-modal-close" onClick={onClose} title="Закрыть">
          ×
        </button>
      </div>

      {error && <div className="form-error">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="group">Group *</label>
          {fieldOptions.group.length > 0 ? (
              <select
                  id="group"
                  name="group"
                  value={formData.group}
                  onChange={handleChange}
                  required
              >
                <option value="">-- Выберите Group --</option>
                {fieldOptions.group.map(option => (
                    <option key={option.id} value={option.option_value}>
                      {option.option_text}
                    </option>
                ))}
              </select>
          ) : (
              <input
                  id="group"
                  name="group"
                  value={formData.group}
                  onChange={handleChange}
                  placeholder="Введите group"
                  required
              />
          )}
          <small>Поле обязательно для заполнения</small>
        </div>
        <div className="form-group">
          <label htmlFor="assessment_type">Канал поступления *</label>
          {fieldOptions.receipt_channel.length > 0 ? (
              <select
                  id="receipt_channel"
                  name="receipt_channel"
                  value={formData.receipt_channel}
                  onChange={handleChange}
                  required
              >
                <option value="">-- Выберите канал поступления --</option>
                {fieldOptions.receipt_channel.map(option => (
                    <option key={option.id} value={option.option_value}>
                      {option.option_text}
                    </option>
                ))}
              </select>
          ) : (
              <input
                  id="receipt_channel"
                  name="receipt_channel"
                  value={formData.receipt_channel}
                  onChange={handleChange}
                  placeholder="Введите канал поступления"
                  required
              />
          )}
          <small>Поле обязательно для заполнения</small>
        </div>
        <div className="form-group">
          <label htmlFor="assessment_type">Тип оценки *</label>
          {fieldOptions.assessment_type.length > 0 ? (
              <select
                  id="assessment_type"
                  name="assessment_type"
                  value={formData.assessment_type}
                  onChange={handleChange}
                  required
              >
                <option value="">-- Выберите тип оценки --</option>
                {fieldOptions.assessment_type.map(option => (
                    <option key={option.id} value={option.option_value}>
                      {option.option_text}
                    </option>
                ))}
              </select>
          ) : (
              <input
                  id="assessment_type"
                  name="assessment_type"
                  value={formData.assessment_type}
                  onChange={handleChange}
                  placeholder="Введите тип оценки"
                  required
              />
          )}
          <small>Поле обязательно для заполнения</small>
        </div>

        <div className="form-group">
          <label htmlFor="agentName">ФИО сотрудника *</label>
          {fieldOptions.operators && fieldOptions.operators.length > 0 ? (
                  <select
                      id="agentName"
                      name="agentName"
                      value={formData.agentName}
                      onChange={(e) => {
                        const selectedName = e.target.value;
                        const selectedOperator = fieldOptions.operators.find(op => `${op.surname} ${op.name}` === selectedName);
                        setFormData(prev => ({
                          ...prev,
                          agentName: selectedName,
                          agentId: selectedOperator ? selectedOperator.id : ''
                        }));
                      }}
                      required
                      disabled={isEditing && !user.superuser && !user.admin}
                      title={isEditing && !user.superuser && !user.admin ? "Изменение ФИО сотрудника доступно только администраторам и суперпользователям" : ""}
                  >
                    <option value="">-- Выберите сотрудника --</option>
                    {fieldOptions.operators.map(operator => (
                        <option key={operator.id} value={`${operator.surname} ${operator.name}`}>
                          {`${operator.surname} ${operator.name}`}
                        </option>
                    ))}
                  </select>
              )
              : fieldOptions.agent_name.length > 0 ? (
                      <select
                          id="agentName"
                          name="agentName"
                          value={formData.agentName}
                          onChange={handleChange}
                          required
                      >
                        <option value="">-- Выберите сотрудника --</option>
                        {fieldOptions.agent_name.map(option => (
                            <option key={option.id} value={option.option_value}>
                              {option.option_text}
                            </option>
                        ))}
                      </select>
                  )
                  : (
                      <input
                          type="text"
                          id="agentName"
                          name="agentName"
                          value={formData.agentName}
                          onChange={handleChange}
                          required
                          readOnly={isEditing && !user.superuser && !user.admin}
                          title={isEditing && !user.superuser && !user.admin ? "Изменение ФИО сотрудника доступно только администраторам и суперпользователям" : ""}
                      />
                  )}
          <small>Поле обязательно для заполнения</small>
          {isEditing && !user.superuser && !user.admin &&
              <small>Изменение ФИО сотрудника доступно только администраторам и суперпользователям</small>}
        </div>

        <div className="form-group">
          <label htmlFor="impact">Impact *</label>
          {fieldOptions.impact.length > 0 ? (
              <select
                  id="impact"
                  name="impact"
                  value={formData.impact}
                  onChange={handleChange}
                  required
              >
                <option value="">-- Выберите Impact --</option>
                {fieldOptions.impact.map(option => (
                    <option key={option.id} value={option.option_value}>
                      {option.option_text}
                    </option>
                ))}
              </select>
          ) : (
              <input
                  id="impact"
                  name="impact"
                  value={formData.impact}
                  onChange={handleChange}
                  placeholder="Введите Impact"
              />
          )}
          <small>Поле обязательно для заполнения</small>
        </div>

        <div className="form-group">
          <label htmlFor="url_ticket">Ссылка на SRQ (URL) *</label>
          <input
              type="text"
              id="url_ticket"
              name="url_ticket"
              value={formData.url_ticket}
              onChange={handleChange}
              placeholder="Введите ссылку"
          />
          <small>Поле обязательно для заполнения</small>
        </div>

        <div className="form-group">
          <label htmlFor="srq">SRQ *</label>
          <input
              type="text"
              id="srq"
              name="srq"
              value={formData.srq}
              onChange={handleChange}
              placeholder="Введите SRQ"
          />
          <small>Поле обязательно для заполнения</small>
        </div>

        <div className="form-group">
          <label htmlFor="subject2">Subject *</label>
          {fieldOptions.subject2.length > 0 ? (
              <select
                  id="subject2"
                  name="subject2"
                  value={formData.subject2}
                  onChange={handleChange}
              >
                <option value="">-- Выберите subject --</option>
                {fieldOptions.subject2.map(option => (
                    <option key={option.id} value={option.option_value}>
                      {option.option_text}
                    </option>
                ))}
              </select>
          ) : (
              <input
                  type="text"
                  id="subject2"
                  name="subject2"
                  value={formData.subject2}
                  onChange={handleChange}
                  placeholder="Введите subject2"
              />
          )}
          <small>Поле обязательно для заполнения</small>
        </div>

        <div className="form-group">
          <label htmlFor="service">Сервис *</label>
          {fieldOptions.service.length > 0 ? (
              <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
              >
                <option value="">-- Выберите сервис --</option>
                {fieldOptions.service.map(option => (
                    <option key={option.id} value={option.option_value}>
                      {option.option_text}
                    </option>
                ))}
              </select>
          ) : (
              <input
                  type="text"
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  placeholder="Введите сервис"
                  required
              />
          )}
          <small>Поле обязательно для заполнения</small>
        </div>

        <div className="form-group">
          <label htmlFor="status">Статус *</label>
          {fieldOptions.status.length > 0 ? (
              <select
                  id="status"
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  required
              >
                <option value="">-- Выберите статус --</option>
                {fieldOptions.status.map(option => (
                    <option key={option.id} value={option.option_value}>
                      {option.option_text}
                    </option>
                ))}
              </select>
          ) : (
              <input
                  type="text"
                  id="status"
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  placeholder="Введите статус"
                  required
              />
          )}
          <small>Поле обязательно для заполнения</small>
        </div>

        <div className="form-group">
          <label htmlFor="os_specialist">Специалист, давший ОС</label>
          {fieldOptions.os_specialist.length > 0 ? (
              <select
                  id="os_specialist"
                  name="os_specialist"
                  value={formData.os_specialist}
                  onChange={handleChange}
              >
                <option value="">-- Выберите специалиста --</option>
                {fieldOptions.os_specialist.map(option => (
                    <option key={option.id} value={option.option_value}>
                      {option.option_text}
                    </option>
                ))}
              </select>
          ) : (
              <input
                  type="text"
                  id="os_specialist"
                  name="os_specialist"
                  value={formData.os_specialist}
                  onChange={handleChange}
                  placeholder="Введите специалиста, давшего ОС"
              />
          )}
        </div>

        <div className="form-group">
          <label htmlFor="feedback">ОС при обработке</label>
          <textarea
              id="feedback"
              name="feedback"
              className="comment-textarea"
              rows="3"
              value={formData.feedback}
              onChange={handleChange}
              placeholder="Введите ОС при обработке"
          ></textarea>
        </div>


        <div className="form-group">
          <label htmlFor="comment">Комментарий</label>
          <textarea
              id="comment"
              name="comment"
              className="comment-textarea"
              rows="3"
              value={formData.comment}
              onChange={handleChange}
              placeholder="Общий комментарий по оценке"
          ></textarea>
        </div>

        <h4>Критерии оценки *</h4>
        <div className="criteria-list">
          {formData.criteria.map((criterion, index) => {
            // Проверяем, должен ли критерий отображаться
            const shouldShow = !criterion.dependencies || criterion.dependencies.length === 0 ||
                (criterion.dependencies &&
                    criterion.dependencies.some(dep =>
                        fieldValues[dep.field_name] &&
                        dep.field_value === fieldValues[dep.field_name]
                    ));

            // Если критерий не должен отображаться, подставляем дефолтный вариант
            if (!shouldShow) {
              if (criterion.default_option_id && (!criterion.selectedOptionId || criterion.selectedOptionId !== criterion.default_option_id)) {
                const defaultOption = criterion.options.find(opt => opt.id === criterion.default_option_id);
                if (defaultOption) {
                  // Подставляем дефолтный вариант и начисляем баллы
                  handleCriteriaOptionChange(criterion.id, criterion.default_option_id);
                }
              }
              return null; // Не отображаем критерий
            }

            return (
                <div key={criterion.id} className="criteria-item" style={{
                  borderLeft: criterion.critical ? '5px solid orange' : '5px solid transparent',
                  backgroundColor: criterion.critical ? '#fff8e1' : 'transparent'
                }}>
                  <div
                      className="criteria-label"
                      title={criterion.comment_prompt || 'Нет подсказки'}
                  >
                    <strong>{criterion.name}</strong>
                  </div>
                  <div className="criteria-options">
                    <select
                        value={criterion.selectedOptionId || ''}
                        onChange={(e) => handleCriteriaOptionChange(criterion.id, Number(e.target.value))}
                        required
                        className="option-select"
                        style={{width: '100%', maxWidth: '400px'}}
                    >
                      <option value="">-- Выберите вариант --</option>
                      {criterion.options.map((option) => (
                          <option
                              key={option.id}
                              value={option.id}
                              style={{
                                whiteSpace: 'normal',
                                wordWrap: 'break-word',
                                wordBreak: 'break-word',
                                maxWidth: '380px'
                              }}
                          >
                            {option.text} (баллы: {option.score})
                          </option>
                      ))}
                    </select>
                  </div>
                  {index < formData.criteria.length - 1 && <div className="criteria-divider"></div>}
                </div>
            );
          })}
        </div>


        <div className="modal-actions">
          {onClose && (
              <button
                  type="button"
                  className="btn-cancel"
                  onClick={onClose}
                  disabled={submitting}
              >
                Отмена
              </button>
          )}
          <button
              type="submit"
              className="btn-submit"
              disabled={submitting}
          >
            {submitting ? 'Сохранение...' : 'Сохранить оценку'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CallAssessmentForm;